import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { IVesselInformationMySuffix } from 'src/app/shared/model/vessel-information-my-suffix.model';
import { VesselInformationMySuffixService } from './vessel-information-my-suffix.service';

@Component({
    selector: 'jhi-vessel-information-my-suffix-delete-dialog',
    templateUrl: './vessel-information-my-suffix-delete-dialog.component.html'
})
export class VesselInformationMySuffixDeleteDialogComponent {
    vesselInformation: IVesselInformationMySuffix;

    constructor(
        private vesselInformationService: VesselInformationMySuffixService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager
    ) {}

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.vesselInformationService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'vesselInformationListModification',
                content: 'Deleted an vesselInformation'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-vessel-information-my-suffix-delete-popup',
    template: ''
})
export class VesselInformationMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(private activatedRoute: ActivatedRoute, private router: Router, private modalService: NgbModal) {}

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ vesselInformation }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(VesselInformationMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.vesselInformation = vesselInformation;
                this.ngbModalRef.result.then(
                    result => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    },
                    reason => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
